import styled, { css } from 'styled-components';

import { ButtonSize, ButtonVariant } from './Button.type';

const primaryStyles = css`
  background-color: var(--textAndLabels-main);
  color: var(--bg-main);

  &:hover {
    background-color: var(--primary-hover);
  }
`;

const secondaryStyles = css`
  background-color: var(--bg-secondary);
  color: var(--textAndLabels-main);

  &:hover {
    background-color: var(--system-lightBlue);
  }
`;

const outlinedStyles = css`
  background-color: var(--bg-main);
  border: 1px solid var(--border-main);
  color: var(--textAndLabels-main);

  &:hover {
    background-color: var(--bg-secondary);
  }
`;

const infoStyles = css`
  background-color: var(--system-lightBlue);
  color: var(--system-blue);

  &:hover {
    background-color: #cee1ff;
  }
`;

const errorStyles = css`
  background-color: #ffeef0;
  color: #ff586d;

  &:hover {
    background-color: #ffdee2;
  }
`;

const mediumStyles = css`
  height: 54px;
  font-size: 15px;
`;

const smallStyles = css`
  height: 40px;
  font-size: 14px;
`;

const isLoadingStyles = css`
  background-color: var(--textAndLabels-tertiary);
  color: transparent;
  cursor: wait;

  &:before {
    content: '';
    border: 2px solid #f1f1f1;
    border-top-color: #8d8f97;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    position: absolute;
    animation: spin 1s linear infinite;
  }

  &:hover {
    background-color: var(--textAndLabels-tertiary);
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

function getVariant(variant?: ButtonVariant) {
  switch (variant) {
    case 'primary':
      return primaryStyles;
    case 'secondary':
      return secondaryStyles;
    case 'outlined':
      return outlinedStyles;
    case 'info':
      return infoStyles;
    case 'error':
      return errorStyles;
    default:
      return css``;
  }
}

function getSize(size?: ButtonSize) {
  switch (true) {
    case size === 's': {
      return smallStyles;
    }
    case size === 'm': {
      return mediumStyles;
    }
    default:
      return css``;
  }
}

export const ButtonBox = styled.button<{
  $variant?: ButtonVariant;
  $size?: ButtonSize;
  $isLoading?: boolean;
  $disabled?: boolean;
  $fullWidth?: boolean;
}>`
  border: none;
  border-radius: 28px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 11px 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $variant }) => getVariant($variant)}

  &:disabled {
    background-color: var(--textAndLabels-tertiary);
    cursor: not-allowed;
  }

  ${({ $size }) => getSize($size)}
  ${({ $isLoading }) => $isLoading && isLoadingStyles}
  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      width: 100%;
    `}
`;
